import './LeadSources.scss'

import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { connectModal } from 'redux-modal'
import ReactTooltip from 'react-tooltip'
import cx from 'bem-classnames'

import { prettyShortNumber } from 'common/util/helper'
import moment from 'moment-timezone'

import ProgressCircle from 'common/views/components/ProgressCircle'
import ProgressBar from 'common/views/components/ProgressBar'
import StackedBars from 'common/views/components/StackedBars'

import { fetchLeadSourceDetails } from 'broker/redux/account'

import {
  LEAD_SOURCE_HIGH_CUT_OFF, LEAD_SOURCE_LOW_CUT_OFF
} from 'common/constants'

import { segmentEventTracker } from 'common/analytics'

const renderSingleColumnStat = (headerLabel, headerValue, firstLabel, firstValue, lastLabel, lastValue) => {
  return (
    <div className="LeadSources__modal--details--stat">
      <div className="LeadSources__modal--details--stat--header">
        <div className="LeadSources__modal--details--stat--label">{headerLabel}</div>
        <div className="LeadSources__modal--details--stat--value">{headerValue || 0}</div>
      </div>
      <div className="LeadSources__modal--details--stat--body">
        <div className="LeadSources__modal--details--stat--small-label">{firstLabel}</div>
        <div className="LeadSources__modal--details--stat--small-value">{firstValue || 0}</div>
        <div className="LeadSources__modal--details--stat--small-label">{lastLabel}</div>
        <div className="LeadSources__modal--details--stat--small-value">{lastValue || 0}</div>
      </div>
    </div>
  )
}

const renderDoubleColumnStat = (headerLabel, headerValue, firstLabel, firstValue, secondLabel, secondValue, thirdLabel, thirdValue, lastLabel, lastValue) => {
  return (
    <div className="LeadSources__modal--details--stat">
      <div className="LeadSources__modal--details--stat--header">
        <div className="LeadSources__modal--details--stat--label">{headerLabel}</div>
        <div className="LeadSources__modal--details--stat--value">{headerValue || 0}</div>
      </div>
      <div className="LeadSources__modal--details--stat--body">
        <div className="LeadSources__modal--details--stat--col">
          <div className="LeadSources__modal--details--stat--small-label">{firstLabel}</div>
          <div className="LeadSources__modal--details--stat--small-value">{firstValue || 0}</div>
          <div className="LeadSources__modal--details--stat--small-label">{secondLabel}</div>
          <div className="LeadSources__modal--details--stat--small-value">{secondValue || 0}</div>
        </div>
        <div className="LeadSources__modal--details--stat--col">
          <div className="LeadSources__modal--details--stat--small-label">{thirdLabel}</div>
          <div className="LeadSources__modal--details--stat--small-value">{thirdValue || 0}</div>
          <div className="LeadSources__modal--details--stat--small-label">{lastLabel}</div>
          <div className="LeadSources__modal--details--stat--small-value">{lastValue || 0}</div>
        </div>
      </div>
    </div>
  )
}

const renderLeadSourceDetails = (details) => {
  return (
    <div className="LeadSources__modal--details" key={details.lead_inquiry_source_name}>
      <div className="LeadSources__modal--details--title">{details.lead_inquiry_source_name}</div>
      { details.most_recent_inquiry ? <div className="LeadSources__modal--details--date">Last Lead Received: <span className="LeadSources__modal--details--date--bold">{ moment.utc(details.most_recent_inquiry).local().format("MMM DD, YYYY") }</span></div> : null }
      <div className="LeadSources__modal--details--container">
        { renderSingleColumnStat(
            'Unique Leads', details.lead_count,
            'Received', details.lead_inquiry_count,
            'Duplicates', details.lead_inquiry_count - details.lead_count
        ) }
        { renderSingleColumnStat(
            'Working', details.working_new_lead_count + details.working_revived_lead_count,
            'New', details.working_new_lead_count,
            'Revived', details.working_revived_lead_count
        ) }
        { renderSingleColumnStat(
            'Stopped Working', details.stopped_failed_screen_lead_count + details.stopped_no_agents_lead_count,
            'Failed Screen', details.stopped_failed_screen_lead_count,
            'No Agents Found', details.stopped_no_agents_lead_count
        ) }
        { renderSingleColumnStat(
            'Made Contact', details.made_contact_lead_count,
            'Total Call Attempts', details.call_count,
            'Total SMS Attempts', details.sms_count
        ) }
        { renderDoubleColumnStat(
            'Referred', details.network_referred_count + details.network_referred_count,
            'My Team', details.broker_referred_count,
            'Network', details.network_referred_count,
            'Released', details.broker_released_count,
            'Released', details.network_released_count
        ) }
        { renderSingleColumnStat(
            'Closed', details.broker_closed_count + details.network_closed_count,
            'My Team', details.broker_closed_count,
            'Network', details.network_closed_count
        ) }
      </div>
    </div>
  )
}

class LeadSourceDetail extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showDetails: false
    }
  }

  getPercentage = (val) => {
    return val ? (val * 100).toFixed(0) : 0
  }

  componentWillMount() {
    this.props.dispatch(fetchLeadSourceDetails(this.props.lead_source_type_id))
  }

  render() {

    const props = this.props

    const triangleClasses = {
      name: 'LeadSources__modal--triangle',
      modifiers: ['high', 'average', 'low', 'none']
    }

    const nameKey = props.name_key ? props.name_key : 'other'
    const name = props.name ? props.name : 'Other Sources'
    const logoClasses = ['LeadSourceTablet__title-sec--logo', 'LeadSources__modal--logo', `LeadSourceTablet__title-sec--logo--${nameKey}`]
    const titleClasses = {
      name: 'LeadSources__modal--header--title',
      modifiers: ['extra-padding']
    }

    const ecr = this.props.ecr * 100
    const showEcr = (props.pipeline && props.pipeline['total']) || 0 > 0
    const categorization = showEcr ? (ecr > LEAD_SOURCE_HIGH_CUT_OFF ? 'high' : ecr < LEAD_SOURCE_LOW_CUT_OFF ? 'low' : 'average') : 'none'

    const { pipeline={}, all_time_summary={}, summary_30_day={}, summary_60_day={} } = this.props
    const stackbarData = [
      {title: 'Spoke', value: pipeline['spoke'], label: (pipeline['total'] || 0) + ' Total Referrals'},
      {title: 'Met / Hunted', value: pipeline['met']},
      {title: 'Offers Made', value: pipeline['offer_made']},
      {title: 'Under Contract', value: pipeline['contract']},
      {title: 'Closed', value: pipeline['closed']}
    ]

    return (
      <Modal show={this.props.show} className="LeadSources__modal">
          <div className="LeadSources__modal__close-x" onClick={this.props.handleHide}><div></div></div>
          <Modal.Header bsClass="LeadSources__modal">
            <div className="LeadSources__modal--header">
              <div className={cx(triangleClasses, {[categorization]: true})}></div>

              <div className={logoClasses.join(' ')}>
                <div style={{backgroundImage: `url(${this.props.logo_url})`}}>{!this.props.logo_url ? <div>OS</div> : null }</div>
              </div>

              <div className="pull-left">
                <div className={cx(titleClasses, {['extra-padding']: !this.props.is_confirmed_quality})}>{name}</div>
                { this.props.is_confirmed_quality ? <div className="LeadSources__modal--header--confirmed"><i className="fa fa-check-circle"/> Confirmed Quality</div> : null }
              </div>
              <div className="LeadSources__modal--header--activity">
                { !props.is_active ? <div className="LeadSources__modal--header--inactive"><span>Inactive</span></div> : null }
                <div className="LeadSources__modal--header--label">Last Updated</div>
                <div className="LeadSources__modal--header--date">{props.updated_since}</div>
              </div>
            </div>
          </Modal.Header>

          <Modal.Body>
            {
              !this.state.showDetails ? <div>
                <div className="LeadSources__modal--left-sec">
                  {
                    showEcr ? <div>
                      <ProgressCircle
                        type='lead-sources'
                        value={ecr}
                        categorization={categorization}
                        scaleMin={0}
                        scaleMax={LEAD_SOURCE_HIGH_CUT_OFF + 1.5}
                      />
                      <div className="LeadSources__modal--left-sec--label">Expected Close Rate <i className="fa fa-question-circle" data-tip="Projections based on Opcity data" /></div>
                    </div> : <div>
                        <div className="LeadSources__modal--left-sec--house"/>
                        <div className="LeadSources__modal--left-sec--label--large">No leads referred yet.</div>
                        <div className="LeadSources__modal--left-sec--label--gray">Check back soon.</div>
                      </div>
                  }

                  <hr />

                  <div className="LeadSources__modal--left-sec--label left-align">Leads Received</div>
                  <div className="LeadSources__modal--left-sec--data-row">
                    <div className="LeadSources__modal--left-sec--data">
                      <label>All-Time</label>
                      <div className={!all_time_summary.lead_count ? 'LeadSources__modal--left-sec--data-lighter' : null }>{all_time_summary.lead_count || '—'}</div>
                    </div>
                    <div className="LeadSources__modal--left-sec--data">
                      <label>Avg Prop. Value</label>
                      <div className={!all_time_summary.avg_price ? 'LeadSources__modal--left-sec--data-lighter' : null }>{prettyShortNumber(all_time_summary.avg_price, true)}</div>
                    </div>
                  </div>

                  <div className="LeadSources__modal--left-sec--data-row">
                    <div className="LeadSources__modal--left-sec--data">
                      <label>Past 30 Days</label>
                      <div className={!summary_30_day.lead_count ? 'LeadSources__modal--left-sec--data-lighter' : null }>{summary_30_day.lead_count || '—'}</div>
                    </div>
                    <div className="LeadSources__modal--left-sec--data">
                      <label>Past 60 Days</label>
                      <div className={!summary_60_day.lead_count ? 'LeadSources__modal--left-sec--data-lighter' : null }>{summary_60_day.lead_count || '—'}</div>
                    </div>
                  </div>

                  <hr />

                  <div className="LeadSources__modal--left-sec--transaction">
                    <div className="LeadSources__modal--left-sec--label-inline left-align">Transaction Volume</div>
                    <div className="LeadSources__modal--left-sec--data LeadSources__modal--left-sec--data--quarters pull-right">
                      <label>Forecast <i className="fa fa-question-circle" data-tip="The total dollar amount of home transactions that is forecasted based on a combination of the average price range of the all active transactions and Opcity’s estimated close rate." /></label>
                      <div className={!this.props.forecast ? 'LeadSources__modal--left-sec--data-lighter' : 'LeadSources__modal--left-sec--data-green' }>{prettyShortNumber(this.props.forecast, true)}</div>
                    </div>
                  </div>

                  <hr className="LeadSources__modal--left-sec--hr"/>

                  <div>
                    <div className="LeadSources__modal--left-sec--data">
                      &nbsp;
                    </div>
                    <div className="LeadSources__modal--left-sec--data">
                      <div className="LeadSources__modal--left-sec--data">
                        <label className="LeadSources__modal--left-sec--data--small-label">Your Team</label>
                      </div>
                      <div className="LeadSources__modal--left-sec--data">
                        <label className="LeadSources__modal--left-sec--data--small-label">Other Brokers</label>
                      </div>
                    </div>

                    <div className="LeadSources__modal--left-sec--data">
                      <label>Closed Volume</label>
                    </div>
                    <div className="LeadSources__modal--left-sec--data">
                      <div className="LeadSources__modal--left-sec--data">
                        <div className={"LeadSources__modal--left-sec--data--small-data LeadSources__modal--left-sec--data-green" + (!this.props.internal_closes_to_date ? ' LeadSources__modal--left-sec--data-lighter' : '') }>{this.props.internal_closes_to_date ? prettyShortNumber(this.props.internal_closes_to_date, true) : '—'}</div>
                      </div>
                      <div className="LeadSources__modal--left-sec--data">
                        <div className={"LeadSources__modal--left-sec--data--small-data LeadSources__modal--left-sec--data-green" + (!this.props.external_closes_to_date ? ' LeadSources__modal--left-sec--data-lighter' : '') }>{this.props.external_closes_to_date ? prettyShortNumber(this.props.external_closes_to_date, true) : '—'}</div>
                      </div>
                    </div>

                    <div className="LeadSources__modal--left-sec--data">
                      <label>Closed Transactions</label>
                    </div>
                    <div className="LeadSources__modal--left-sec--data">
                      <div className="LeadSources__modal--left-sec--data">
                        <div className={"LeadSources__modal--left-sec--data--small-data" + (!this.props.internal ? ' LeadSources__modal--left-sec--data-lighter' : '') }>{this.props.internal || '—'}</div>
                      </div>
                      <div className="LeadSources__modal--left-sec--data">
                        <div className={"LeadSources__modal--left-sec--data--small-data" + (!this.props.external ? ' LeadSources__modal--left-sec--data-lighter' : '') }>{this.props.external || '—'}</div>
                      </div>
                    </div>
                  </div>
                  <div className="LeadSources__modal--left-sec--link">
                    <a onClick={() => {
                      this.setState({showDetails:true})

                      segmentEventTracker('Modal Shown', {
                        'modal_name': 'LeadSourceTabletDetails',
                        'lead_source_name': name,
                        'lead_source_type_id': props.lead_source_type_id,
                        'lead_source_is_confirmed_quality': props.is_confirmed_quality,
                        'lead_source_array_placement': props.leadSourceArrayIdx,
                        'lead_source_performance_categorization': categorization,
                        'lead_source_is_active': props.is_active
                      })
                    }}>View Lead Source Activity <i className="fa fa-arrow-circle-right"/></a>
                  </div>
                </div>

                <div className="LeadSources__modal--right-sec">
                  <div className="LeadSources__modal--right-sec--bar-section">
                    <div className="LeadSources__modal--right-sec--label">Contact Performance</div>
                    <div className="LeadSources__modal--right-sec--text">
                      For this lead source, at what rate is contact made with clients?
                    </div>
                    <ProgressBar averagePercent={78} valuePercent={this.getPercentage(this.props.contact_rate)} /> {/* NOTE - 78% is hard coded */}
                  </div>

                  <div className="LeadSources__modal--right-sec--bar-section">
                    <div className="LeadSources__modal--right-sec--label">Referral Performance</div>
                    <div className="LeadSources__modal--right-sec--text">
                      For this lead source, at what rate are clients being referred?
                    </div>
                    <ProgressBar averagePercent={23.5} valuePercent={this.getPercentage(this.props.assignment_rate)} /> {/* NOTE - 23.5% is hard coded */}
                  </div>

                  <div className="LeadSources__modal--right-sec--bar-section">
                    <div className="LeadSources__modal--right-sec--label">Pipeline Performance</div>
                    <div className="LeadSources__modal--right-sec--text">
                      How are agents working referrals from your lead source?
                    </div>
                    <StackedBars data={stackbarData} />
                  </div>
                </div>
              </div> : <div className="LeadSources__modal--details-sec">
                <a onClick={() => this.setState({showDetails:false})}><i className="fa fa-arrow-circle-left"/> Back To Lead Source Details</a>
                {
                  this.props.account.lead_source_details ? this.props.account.lead_source_details.map(renderLeadSourceDetails) : null
                }
              </div>
            }
          </Modal.Body>

          <Modal.Footer>
              <Button onClick={this.props.handleHide} bsStyle="default">Close</Button>
          </Modal.Footer>
          <ReactTooltip />
      </Modal>
    )
  }
}

const LeadSourceDetailModal = connectModal({ name: 'LeadSourceDetailModal', destroyOnHide: true })(LeadSourceDetail)
export default LeadSourceDetailModal
